module.exports = __webpack_public_path__ + "static/media/drp-personal-stories.83776b5b.svg";